export default "@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;";